import React, { useState, useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import {
  _getSelectedOption,
  _getBaseUrl,
  _isFirstRender,
  _getCSRFTokenValue,
} from "../utils/helper";
import api from "../utils/api";
import { Loader, Pagination } from "../atoms";
import { KeywordSearch, YearDropDown, TopicDropDown, FilterDropDown } from "../forms";
import { CardLibrary } from "../cards";

const INITIAL_VALUES = {
  start_year: "",
  end_year: "",
  topics: [],
  organisations: [],
  languages: [],
  types: [],
  regionsCountries: [],
  keywords: [],
  skip: 0,
  take: 15,
};

import StateView from "../utils/StateView";

const Library = (props) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [values, setValues] = useState(INITIAL_VALUES);
  const [posts, setPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [tags, setTags] = useState([]);
  const [isFiltersExpanded, setisFiltersExpanded] = useState(false);
  
  const isFirstLoad = _isFirstRender();
  const pageTitle = props?.data["title"] || "Library";

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const keyword = decodeURIComponent(urlParams.get("keyword"));
  //   const topic = decodeURIComponent(urlParams.get("topic"));

  //   if (keyword !== null && keyword !== '' && keyword !== 'null') {
  //     console.log('AA', keyword);
  //     setValues({...INITIAL_VALUES, ['keywords']: [keyword], ['skip']: 0});
  //     addRemoveTags('keywords', keyword, true);
  //   }

  //   if (topic !== null && topic !== '' && topic !== 'null') {
  //     console.log('BB', topic);
  //     setValues({...INITIAL_VALUES, ['topics']: [topic], ['skip']: 0});
  //   }

  //   fetchPosts();
  // }, [window.location.search]);

  useEffect(() => {
    fetchFilters();

    const urlParams = new URLSearchParams(window.location.search);
    const keyword = decodeURIComponent(urlParams.get("keyword"));
    const topic = decodeURIComponent(urlParams.get("topic"));

    // ATM, from home page, its not possible to have both keyword and topic param at the same time
    if (keyword !== null && keyword !== '' && keyword !== 'null') {
      setValues({...INITIAL_VALUES, ['keywords']: [keyword], ['skip']: 0});
      addRemoveTags('keywords', keyword, true);
      return;
    }

    if (topic !== null && topic !== '' && topic !== 'null') {
      setValues({...INITIAL_VALUES, ['topics']: [topic], ['skip']: 0});
      return;
    }

    fetchPosts();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) {
      fetchPosts();
    }
  }, [values]);

  // Fetch filter options from API
  const fetchFilters = () => {
    setIsLoadingFilters(true);

    api
      .get(_getBaseUrl("api/filterlistoptions"))
      // .get("/filterlistoptions")
      .then((res) => {
        setIsLoadingFilters(false);
        setFilterOptions(res.data);

        // Check if url has topic param
        const urlParams = new URLSearchParams(window.location.search);
        const topic = decodeURIComponent(urlParams.get("topic"));

        if (topic !== null && topic !== '' && topic !== 'null') {
          addRemoveTags('topics', topic, true);
        }
      })
      .catch(() => {
        setIsLoadingFilters(false);
      });
  };

  // Fetch Library posts from API
  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const csrfToken = await _getCSRFTokenValue();
    const fields = values;

    api
      .post(_getBaseUrl("api/library/searchandfilter"), fields, {
      // .post("/library/searchandfilter", fields, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsLoadingPosts(false);
        setPosts(res.data.library);
        setTotalPosts(res.data.totalNodes);
      })
      .catch(() => {
        setIsLoadingPosts(false);
      });
  };




  const updateFilters = (key, value) => {
    let filters = {...values, [key]: value, skip: 0};

    setCurrentPage(1);
    setValues(filters);
  }





  const addRemoveTags = (filter, value, addRemove) => {
    let temp = [...tags];

    // True === add
    if (addRemove) {
      temp.push({
        filter,
        value
      });
    } else {
      temp = temp.filter((item) => {
        return !(item.filter === filter && item.value === value);
      });
    }

    setTags(temp);
  }

  const onYearChanged = (name, value) => {
    const year = value.toString();
    let updatedValue = { ...values, [name]: year, ['skip']: 0 };

    // If start year is not selected
    if (name === 'start_year' && values.end_year === '') {
      updatedValue = { ...updatedValue, end_year: filterOptions.years.max };
    }

    // If end year is not selected
    if (name === 'end_year' && values.start_year === '') {
      updatedValue = { ...updatedValue, start_year: filterOptions.years.min };
    }

    // If start year is greater than end year, set start year to end year    
    if (name === 'start_year' && updatedValue.end_year !== '' && year > updatedValue.end_year) {
      updatedValue = { ...updatedValue, start_year: updatedValue.end_year };
    }

    // If end year is greater than start year, set end year to start year    
    if (name === 'end_year' && updatedValue.start_year !== '' && year < updatedValue.start_year) {
      updatedValue = { ...updatedValue, end_year: updatedValue.start_year};
    }
    
    setCurrentPage(1);
    setValues(updatedValue);

    let updatedTags = [...tags];
    let foundTagIndex;

    const foundTag = updatedTags.find((item, index) => { 
      if (item.filter === "year_range") {
        foundTagIndex = index;
      }
      return item.filter === "year_range"; 
    });

    // No year range tag found
    if (foundTag === undefined) {
      addRemoveTags("year_range", "From " + updatedValue.start_year + " to " + updatedValue.end_year, true);
    } else {

      updatedTags.splice(foundTagIndex, 1);
      updatedTags.push({
        filter: "year_range",
        value: "From " + updatedValue.start_year + " to " + updatedValue.end_year
      });
      setTags(updatedTags);
    }
  };

  const removeYearRange = () => {
    let updatedTags = [...tags];
    let foundTagIndex;

    const foundTag = updatedTags.map((item, index) => { 
      if (item.filter === "year_range") {
        foundTagIndex = index;
      }
    });

    updatedTags.splice(foundTagIndex, 1);
    setTags(updatedTags);

    setValues({...values, start_year: "", end_year: "", skip: 0});
  }

  const onTopicChanged = (filter, value, checked) => {
    // console.log(value, checked, filterOptions.topics);

    // Check if its a parent
    const parent = filterOptions.topics.filter((item) => {
      return parseInt(item.value) === parseInt(value);
    });

    let updatedValue =  [...values[filter]];
    let updatedTags = [...tags];

    // Parent is checked or unchecked
    if (parent.length > 0) {
      // Get all values into an array
      const subTopicsValues = parent[0].subTopics.map((item) => {
        return item.value;
      });

      // If parent is checked
      if (checked) {
        let newTags = [];
        
        // Loop through all values
        subTopicsValues.map((item) => {
          updatedValue.push(item);

          // Check if value already has a tag, if not then add to tags
          if (updatedTags.find((tag) => { return tag.value === item; }) === undefined) {
            newTags.push({
              filter,
              value: item
            });
          }
        });

        // Merge existing tags with new tags
        updatedTags = [...updatedTags, ...newTags];
      } else { // Parent is unchecked
        subTopicsValues.map((item) => {
          // Remove values
          updatedValue = updatedValue.filter((v) => {
            // Remove tags
            updatedTags = updatedTags.filter((tag) => {
              return tag.value !== item;
            });

            return item !== v;
          });
        });
      }

      setTags(updatedTags);
    // Sub topic is checked or unchecked
    } else {
      if (checked) {
        addRemoveTags(filter, value, true);
        updatedValue.push(value);
      } else {
        addRemoveTags(filter, value, false);
        updatedValue = updatedValue.filter((item) => {
          return item !== value;
        });
      }
    }

    updateFilters(filter, updatedValue);
    // setValues({ ...values, [filter]: updatedValue, skip: 0 });
  };

  const onFilterChanged = (filter, value, checked) => {
    // console.log("onFilterChanged", filter, value, checked);

    let updatedValue =  [...values[filter]];

    if (checked) {
      addRemoveTags(filter, value, true);
      updatedValue.push(value);
    } else {
      addRemoveTags(filter, value, false);
      updatedValue = updatedValue.filter((item) => {
        return item !== value;
      });
    }

    updateFilters(filter, updatedValue);
    // setValues({ ...values, [filter]: updatedValue, skip: 0 });
  };

  // Key up handler for Keyword input
  const onKeyUpHandler = (e) => {
    // console.log(e.key, e.target.value);

    if (e.key === 'Enter') {
      const keyword = e.target.value;
      const isWhitespaceString = !keyword.replace(/\s/g, '').length;

      // Check if only spaces or empty
      if (isWhitespaceString) { return; }

      let updatedKeywords = [...values.keywords];

      // Check if keywords already exists
      if (updatedKeywords.indexOf(keyword) >= 0) { return; }

      updatedKeywords.push(keyword);

      updateFilters('keywords', updatedKeywords);
      // setValues({ ...values, ['keywords']: updatedKeywords, skip: 0 });
      addRemoveTags('keywords', keyword, true);

      // Reset keyword input to blank
      e.target.value = '';
    }
  };

  const removeKeyword = (keyword) => {
    let updatedKeywords = [...values.keywords];

    updatedKeywords = updatedKeywords.filter((item) => {
      return item !== keyword;
    })

    updateFilters('keywords', updatedKeywords);
    // setValues({ ...values, ['keywords']: updatedKeywords, skip: 0 });
    addRemoveTags('keywords', keyword, false);
  }

  const clearFilters = () => {
    setValues(INITIAL_VALUES);
    setTags([]);
  };

  const navigatePage = (goNext) => {
    let page;
    let skip;

    if (goNext) {
      page = currentPage + 1;
    } else {
      page = currentPage - 1;
    }

    skip = (page - 1) * values.take;

    setValues({...values, skip});
    setCurrentPage(page);
  }

  // Tags on cards only consists of Topics
  const onTagClick = (tid) => {
    let topics =  [...values['topics']];

    const findItem = topics.filter((item) => {
      return item === tid;
    });
    if (findItem.length <= 0) {
      topics = [...topics, tid];
      addRemoveTags('topics', tid, true);
      updateFilters('topics', topics);
      // setValues({...values, topics, skip: 0});
    }
  }

  return (
    <React.Fragment>
      <div className="bg-temaBlue h-[200px] flex flex-col justify-end">
        <div className="container relative">
          <h1 className="h2 text-white text-center !mb-6">{ pageTitle }</h1>
          <KeywordSearch
            placeholder="Keyword search"
            class="h-[75px] lg:h-[90px] sm:max-w-[500px] lg:max-w-[700px] block w-full px-10 mx-auto text-lg lg:text-2xl input-keyword"
            onKeyUp={onKeyUpHandler}
          />
          <img
            src={_getBaseUrl("src/assets/gradient-bar.png", true)}
            alt=""
            className="h-[6px] max-w-[calc(100vw_-_4rem)] sm:max-w-[500px] lg:max-w-[700px] w-full absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[6px]"
          />
        </div>
      </div>

      {!isLoadingFilters && (
        <div className="container my-10 md:mt-20 md:mb-8">
          <div className="border border-black md:border-none px-4 md:p-0">
            <div
              className="h-[70px] pr-4 md:hidden flex items-center justify-between cursor-pointer"
              onClick={() => {setisFiltersExpanded(!isFiltersExpanded)}}
            >
              <span className="text-sm lg:text-base">Filters</span>
              <img src={`${_getBaseUrl('src/assets/icon-download.svg', true)}`} alt="" className={`filter brightness-0 ${isFiltersExpanded ? 'rotate-180' : ''}`} />
            </div>

            <div className={`pb-4 ${isFiltersExpanded ? 'block' : 'hidden'} md:!block`}>
              <div className="grid gap-2 md:gap-0 md:grid-cols-3 xl:grid-cols-6">
                <YearDropDown
                  placeholder="Year range"
                  filter="year"
                  options={filterOptions.years}
                  onChange={onYearChanged}
                  value={{ "start_year": values.start_year, "end_year": values.end_year }}
                  toggleClass="md:border-r-0 md:border-b-0 xl:border-b"
                  trayClass="w-full mt-2 md:mt-0 md:w-[240px]"
                  trayBodyClass="max-h-[500px] overflow-y-auto"
                />
                <TopicDropDown
                  placeholder="Topic"
                  filter="topics"
                  options={filterOptions.topics}
                  onChange={onFilterChanged}
                  value={values.topics}
                  toggleClass="md:border-r-0 md:border-b-0 xl:border-b"
                  trayClass="w-full mt-2 md:mt-0 md:w-[480px]"
                  topicsValues={values.topics}
                />
                <TopicDropDown
                  placeholder="Region/Country"
                  filter="regionsCountries"
                  options={filterOptions.regionsCountries}
                  onChange={onFilterChanged}
                  value={values.regionsCountries}
                  toggleClass="xl:border-r-0 md:border-b-0 xl:border-b"
                  trayClass="w-full mt-2 md:mt-0 md:w-[480px] md:left-[unset] md:right-0 xl:right-[unset] xl:left-0"
                  topicsValues={values.regionsCountries}
                  collapsible={true}
                />
                <FilterDropDown
                  placeholder="Organisation"
                  filter="organisations"
                  options={filterOptions.organisations}
                  onChange={onFilterChanged}
                  value={values.organisations}
                  toggleClass="md:border-r-0"
                  trayClass="w-full mt-2 md:mt-0 md:w-[300px]"
                  trayBodyClass="max-h-[500px] overflow-y-auto"
                />
                <FilterDropDown
                  placeholder="Type"
                  filter="types"
                  options={filterOptions.types}
                  onChange={onFilterChanged}
                  value={values.types}
                  toggleClass="md:border-r-0"
                  trayClass="w-full mt-2 md:mt-0 md:w-[360px]"
                />
                <FilterDropDown
                  placeholder="Language"
                  filter="languages"
                  options={filterOptions.languages}
                  onChange={onFilterChanged}
                  value={values.languages}
                  trayClass="w-full mt-2 md:mt-0 md:w-[240px] 2xl:w-full md:left-[unset] md:right-0"
                  trayBodyClass="max-h-[500px] overflow-y-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      { tags.length > 0 && (
        <div className="container">
          <div className="text-lg mb-3">Applied filters</div>
          <div className="filter-tags--wrapper flex flex-wrap gap-1">
            { tags.map((item) => {
              if (item.filter === "year_range") {
                return <div className="filter-tag">
                  <span>{item.value}</span>
                  <div className="filter-tag--remove" onClick={() => removeYearRange()}></div>
                </div>
              } else if (item.filter === 'keywords' ) { // Keywords
                return <div className="filter-tag">
                  <span>Keyword: {item.value}</span>
                  <div className="filter-tag--remove" onClick={() => removeKeyword(item.value)}></div>
                </div>
              } else if (item.filter !== 'topics' && item.filter !== 'regionsCountries' ) { // Tags for Organisations, Types and Languages
                return <div className="filter-tag">
                  <span>{_getSelectedOption(filterOptions[item.filter], item.value).label}</span>
                  <div className="filter-tag--remove" onClick={() => onFilterChanged(item.filter, item.value, false)}></div>
                </div>
              } else { // Tags for topics, regionsCountries
                return <div className="filter-tag">
                  <span>{_getSelectedOption(filterOptions[item.filter], item.value, true).label}</span>
                  <div className="filter-tag--remove" onClick={() => onFilterChanged(item.filter, item.value, false)}></div>
                </div>
              }
            }) }

            <div className="filter-tag clear cursor-pointer" onClick={() => clearFilters()}>
              <span>Clear all filters</span>
              <div className="filter-tag--remove"></div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-8">
        <div className="container">
          <div className="my-16 xl:mt-16 xl:mb-32">
            {isLoadingPosts && <Loader class="mb-8" />}
            {_.isArray(posts) && posts.length > 0 ? (
              <React.Fragment>
                <div className="text-center text-xl md:text-2xl lg:text-3xl mb-8 md:mb-12 xl:mb-16">{totalPosts} search results</div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-12">
                  {posts.map((post) => (
                    <CardLibrary data={post} onTagClick={onTagClick} />
                  ))}
                </div>

                <div className="sm:flex sm:justify-center h-[50px] mt-10 lg:mt-16">
                    <div className="h-full border border-black flex">
                      <div className={`w-1/3 sm:w-auto h-full flex items-center justify-center px-5 gap-4 cursor-pointer ${currentPage <= 1 && 'opacity-30 pointer-events-none'}`} onClick={() => navigatePage(false)}>
                        <img src={`${_getBaseUrl('src/assets/icon-download.svg', true)}`} alt="" className="filter brightness-0 rotate-90" />
                        <span className="hidden sm:block">Prev page</span>
                      </div>
                      <div className="w-1/3 sm:w-auto h-full flex items-center justify-center px-4 sm:px-10 whitespace-nowrap border-black border-l border-r">{currentPage} of {Math.ceil(totalPosts / values.take)}</div>
                      <div className={`w-1/3 sm:w-auto h-full flex items-center justify-center px-5 gap-4 cursor-pointer ${currentPage >= Math.ceil(totalPosts / values.take) && 'opacity-30 pointer-events-none'}`} 
                        onClick={() => navigatePage(true)}>
                        <span className="hidden sm:block">Next page</span>
                        <img src={`${_getBaseUrl('src/assets/icon-download.svg', true)}`} alt="" className="filter brightness-0 -rotate-90" />
                      </div>
                    </div>
                </div>
              </React.Fragment>
            ) : isLoadingPosts ? null : (
              <p className="text-center">There are no posts available.</p>
            )}
          </div>
        </div>
      </div>

      {/* <StateView title="values" values={values} floating /> */}
      {/* <StateView title="tags" values={tags} class="bottom-4 left-4 right-[unset]" floating /> */}
      {/* <StateView title="total posts" values={totalPosts} class="top-4 bottom-[unset] left-4 right-[unset]" floating /> */}
      {/* <StateView title="filters" values={filterOptions} class="bottom-4 right-96 max-h-[90vh] overflow-y-auto" floating collapsed /> */}

      { (isLoadingPosts || isLoadingFilters) && (
        <Loader />
      )}

    </React.Fragment>
  );
};

export default Library;
